/**
 * NzContent
 * 
 * @Author: Focci
 * @Date: 2024-03-07 17:24:03
 * @Last Modified by: Focci
 * @Last Modified time: 2024-03-07 17:24:03
 */

import { DevelopmentIcons } from './lib'

export default function NzContent({
  house,
  handleIconClick = () => {}
}) {
  const { lot, plan, zoneCode, primaryZoneDescription, url } = house.auPlanZone || {}
  
  return (
    <div className="flex flex-col justify-between gap-4">
      {(lot || plan || zoneCode || primaryZoneDescription || url) && (
        <div className="flex flex-col gap-y-4">
          <div>
            <span className="text-helper">lot</span>
            <span className="ml-2">{lot || '-'}</span>
          </div>
          <div>
            <span className="text-helper">plan</span>
            <span className="ml-2">
              {plan || '-'}
            </span>
          </div>
          <div>
            <span className="text-helper">zoneCode</span>
            <span className="ml-2">{zoneCode || '-'}</span>
          </div>
          <div>
            <span className="text-helper">primaryZoneDescription</span>
            <span className="ml-2">{primaryZoneDescription || '-'}</span>
          </div>
          <div>
            <span className="text-helper">URL</span>
            <span className="ml-2">{url || '-'}</span>
          </div>
        </div>
      )}
      <DevelopmentIcons
        location={house?.stateId ? [house.stateId] : []}
        onClick={handleIconClick}
      />
    </div>
  )
}

// NzContent.propTypes = {
//   className: PropTypes.string,
// }
